import Vue from 'vue'
import Axios from 'axios'
import router from '../_router'
import cookieUtil from '../utils/cookieUtil'
import { filterPath } from '../utils/constant'
import store from './../_vuex'

if (process.env.NODE_ENV === 'production') {
   Axios.defaults.baseURL = 'https://hubeimo.tothemax.cn/api/'
//  Axios.defaults.baseURL = 'http://192.168.1.21:7308'
} else if (process.env.NODE_ENV === 'testing') {
   Axios.defaults.baseURL = 'https://hubeimo.tothemax.cn/api/'
  // Axios.defaults.baseURL = 'http://192.168.1.21:7308'
} else {
   Axios.defaults.baseURL = 'https://hubeimo.tothemax.cn/api/'
//  Axios.defaults.baseURL = 'http://192.168.1.21:7308'
}

Axios.interceptors.request.use(config => {
  try {
    const projectId = store.state.selectProject.projectId
    if (projectId !== null) {
      config.headers['pId'] = projectId
    }
  } catch (e) {
    // to do sth
  }
  if (cookieUtil.get('token')) {
    config.headers.token = cookieUtil.get('token')
  }
  return config
})

Axios.interceptors.response.use(res => {
  if (filterPath.indexOf(router.currentRoute.path) !== -1) {
    return res
  }

  if (res.data.code === 405) { // 未登陆码
    if (sessionStorage.getItem('routerList')) {
      router.push({ name: 'toLogin' })
    }else if (router.history.current.name !== 'login') {
      router.push({ name: 'login' })
    }
  }
  return res
}, err => {
  return Promise.reject(err)
})

Vue.prototype.$axios = Axios



// WEBPACK FOOTER //
// ./src/_axios/index.js